import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import * as UC from './utility.component';
import * as UD from './utility.directive';
import * as UP from './utility.pipe';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		ImageCropperModule,
		NgbModule
	],
	declarations: [
		UC.FeatureNotAvailableDialog,
		UC.ReadMoreDialog,
		UC.FeatureNotAvailable2BDialog,
		UC.ScrollOnHoverComponent,
		UC.ImageCropperDialog,
		UD.GridsterLazyLoadDirective,
		UD.ImgCheckDirective,
		UD.CardImgLazyLoadDirective,
		UD.CarouselNoWrapDirective,
		UD.TrackVisibilityDirective,
		UP.SafePipe,
		UP.FormatDateTimePipe,
		UP.FormatDatePipe
	],
	exports: [
		UC.FeatureNotAvailableDialog,
		UC.ReadMoreDialog,
		UC.FeatureNotAvailable2BDialog,
		UC.ScrollOnHoverComponent,
		UC.ImageCropperDialog,
		UD.GridsterLazyLoadDirective,
		UD.ImgCheckDirective,
		UD.CardImgLazyLoadDirective,
		UD.CarouselNoWrapDirective,
		UD.TrackVisibilityDirective,
		UP.SafePipe,
		UP.FormatDateTimePipe,
		UP.FormatDatePipe
	]
})
export class UtilityModule { }
